/* eslint-disable react/prop-types */
import React, {useState, useCallback, useEffect} from 'react';

import './DataLookUp.scss';

const SearchBar = props => {
  const {searchData, actionDataSentBack, setCurrentPage} = props;

  const [value, setValue] = useState('');
  const [autoData, setAutoData] = useState([]);

  useEffect(() => {
    setAutoData(searchData);
  }, [setAutoData, searchData]);

  /**
   * this is used to populate the dropdown
   */
  const onSubmitSearch = useCallback(entry => {
    setCurrentPage&&setCurrentPage(1);
    if (entry.length > 1) {
      const parent = document.getElementById('dynamic_data');
      while (parent.firstChild && !parent.firstChild.remove()) { }
    }
    autoData.forEach(({org_name, id}) => {
      if (org_name.slice(0, 3).toLowerCase() === entry.toLowerCase()) {
        const option = document.createElement('option');
        option.value = org_name;
        option.id = id;
        (document.getElementById('dynamic_data')).appendChild(option);
      }
    });
  }, [autoData]);

  /**
   * this is used to update the callback that is used to update the table
   */
  const alterTableData = useCallback(key => {
    if(key.length > 0) {
      let filterName = 'org_name';
      if(isNaN(key)){ //if key is string, search with state or org_name
        if(key.length === 2){
          filterName = 'state';
        }
      }
      else { //if key is number, search with org_id
        filterName = 'org_id';
      }
      const findData = searchData.filter(el => (`${el[filterName]}`).toLowerCase().includes(key.toLowerCase()));
      actionDataSentBack(findData);
    }
    else {
      //reset and show all orgs
      actionDataSentBack(searchData);
    }
  }, [searchData, actionDataSentBack]);

  return (
    <div className='flex_container_col cb-input'>
      <input
        autoComplete='off'
        ref={input => input && input.focus()}
        type='text' id='dynamiclist'
        list='dynamic_data'
        placeholder='Search...'
        aria-label='data look up'
        data-testid='datalookuptestid'
        value={value}
        onChangeCapture={event => {
          const val = event.target.value.trim();
          alterTableData(val);
        }}
        onChange={event => {
          const val = event.target.value;
          setValue(val);
          onSubmitSearch(val);
        }}
      />
      <i className='cb-icon cb-search datalookup-search' aria-hidden='true' />
      <datalist id='dynamic_data' />
    </div>
  );
};

export default SearchBar;